export const imageCodes = {

    bannerBg: {
        code: "${merchantId}_tmpl_img_1",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fbann1.jpg?alt=media&token=0ef6c156-5ed6-46b4-b5b4-7ccdd9dde717"
    },

    spotify: {
        code: "${merchantId}_tmpl_img_2",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FSpotify_Logo_RGB_White.png?alt=media&token=a89d51ab-fbfc-4e2f-bad3-3ad266d7e680"
    },

    apple: {
        code: "${merchantId}_tmpl_img_3",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fappmusic.png?alt=media&token=d0b205b4-7197-4d41-ab51-2fc6c31c4c31"
    },

    amazon: {
        code: "${merchantId}_tmpl_img_4",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Famazonmusic.png?alt=media&token=5f4105da-9a3c-4eb6-8e1c-1045bcf280d8"
    },

    youtube: {
        code: "${merchantId}_tmpl_img_5",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fyoutube.png?alt=media&token=3bfee4ed-7d1b-4409-a22c-fd8ce3a3260c"
    },

    tiktok: {
        code: "${merchantId}_tmpl_img_6",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Ftiktok.png?alt=media&token=f233269a-6b91-4b0f-bbc4-9c1b074b9b91"
    },

    whyChoose: {
        code: "${merchantId}_tmpl_img_7",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FWhy_Choose.png?alt=media&token=107494f5-0d20-406b-9375-aa647a66a43b"
    },

    artist1: {
        code: "${merchantId}_tmpl_img_8",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fartist1.jpg?alt=media&token=0f6ff16e-9bee-43c2-ab9d-82b9ba32da29"
    },

    grow: {
        code: "${merchantId}_tmpl_img_9",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fgrow_career.jpeg?alt=media&token=e1bf3cd5-6be1-4a3b-b638-5ec914287dda"
    },

    mpublish: {
        code: "${merchantId}_tmpl_img_10",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fmusic%20publishing.jpg?alt=media&token=4e948644-56f8-47f5-a1e7-86cba0eb4ca5"
    },

    blackBg: {
        code: "${merchantId}_tmpl_img_11",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FblackBG.png?alt=media&token=1a4a3ccb-f27a-4d9d-b9f7-a3eaa3c7a777"
    },

    artist2: {
        code: "${merchantId}_tmpl_img_12",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fartist3.jpg?alt=media&token=3d28fa02-a64f-4769-bc4a-fb049c095b7d"
    }, 

    blueBg: {
        code: "${merchantId}_tmpl_img_13",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FblueBg.png?alt=media&token=b9bbd429-6dfb-4e7f-9ef6-c512fc573130"
    },

}

export const titleCodes = {

    bannerTitle: {
        code: "${merchantId}_tmpl_title_1",
        title: "Sell Your Music Worldwide",
    },

    platformTitle: {
        code: "${merchantId}_tmpl_title_2",
        title: "Unlimited Distribution Starting at $14.99/year",
    },

    chooseTitle: {
        code: "${merchantId}_tmpl_title_3",
        title: "Why Choose YDNM Music",
    },

    chooseTitle1: {
        code: "${merchantId}_tmpl_title_4",
        title: "Unlimited Worldwide Music Distribution",
    },

    chooseTitle2: {
        code: "${merchantId}_tmpl_title_5",
        title: "Unlimited Releases to Social Platforms",
    },

    chooseTitle3: {
        code: "${merchantId}_tmpl_title_6",
        title: "Comprehensive Sales Data",
    },

    howtoSell: {
        code: "${merchantId}_tmpl_title_7",
        title: "How to Sell Your Music Online",
    },

    artist: {
        code: "${merchantId}_tmpl_title_8",
        title: "From Our Artist Community",
    },

    growTitle: {
        code: "${merchantId}_tmpl_title_9",
        title: "Grow Your Career",
    },

    growTitle2: {
        code: "${merchantId}_tmpl_title_10",
        title: "With TuneCore Rewards",
    },

    yourOwn: {
        code: "${merchantId}_tmpl_title_11",
        title: "Be Your Own",
    },

    gDesigner: {
        code: "${merchantId}_tmpl_title_12",
        title: "Graphic Designer",
    },

    mPublishing: {
        code: "${merchantId}_tmpl_title_13",
        title: "Music Publishing",
    },
}

export const textCodes = {

    bannerText1: {
        code: "${merchantId}_tmpl_text_1",
        text: "Get your music on Spotify, Apple Music, TikTok, YouTube, Tidal, Tencent and more."
    },

    bannerText2: {
        code: "${merchantId}_tmpl_text_2",
        text: "Keep 100% ownership of your music and stay in control of your career. Unlimited Releases starting at $14.99/year."
    },
    
    platformText: {
        code: "${merchantId}_tmpl_text_3",
        text: "Get your music on Spotify, Apple Music, TikTok, YouTube, Tidal, Tencent and more. Keep 100% ownership of your music and stay in control of your career."
    },

    chooseText1: {
        code: "${merchantId}_tmpl_text_4",
        text: "Get your music playing in over 150 digital stores and streaming services across 200+ countries worldwide. Starting at $14.99/year."
    },

    chooseText2: {
        code: "${merchantId}_tmpl_text_5",
        text: "Get your music on TikTok, YouTube, Instagram, Facebook, Reels and for no annual fee."
    },

    chooseText3: {
        code: "${merchantId}_tmpl_text_6",
        text: "Find out exactly where fans are downloading and streaming your music so you can increase marketing efforts and plan tours around those cities."
    },

    sellText: {
        code: "${merchantId}_tmpl_text_7",
        text: "Before TuneCore, artists needed a label to get their music sold online. In 2006, we disrupted the industry by partnering directly with Digital Stores to allow any musician to sell their songs worldwide. Today, TuneCore is the world's leading digital music aggregator. Choose an unlimited distribution plan, upload your music, and we'll do the rest. Your music will hit top digital stores, like Spotify and Apple Music, in no time."
    },

    growText1: {
        code: "${merchantId}_tmpl_text_8",
        text: "Receive expert advice from some of the best minds in the industry, gain real insight from top artists, and get VIP access to exclusive TuneCore services."
    },

    growText2: {
        code: "${merchantId}_tmpl_text_9",
        text: "The best part? It's completely free."
    },

    ownText: {
        code: "${merchantId}_tmpl_text_10",
        text: "Create your Cover Art with Layouts, Images, Presets, Filters, Fonts, and Overlays"
    },

    ownText2: {
        code: "${merchantId}_tmpl_text_11}",
        text: "Choose the Breakout Artist plan to customize your TuneCore Cover Art during the upload process."
    },

    publishText: {
        code: "${merchantId}_tmpl_text_12}",
        text: "As an independent songwriter, when your music is sold, streamed, or played on the radio or on the internet, it could be generating income from multiple types of royalties in addition to the money you are already earning from distribution. Let us help you collect even more of your money by:"
    },

    publishList1: {
        code: "${merchantId}_tmpl_text_13}",
        text: "Registering your compositions at societies in over 60 countries around the world"
    },

    publishList2: {
        code: "${merchantId}_tmpl_text_14}",
        text: "Registering and administering your music on YouTube"
    },
}